import { normalizeContactPhoneToE164 } from '@repo/common';

const US_E164 = /^\+1(\d{3})(\d{3})(\d{4})$/;

/** Shows a US E.164 number as `(555) 555-0100`; anything else is returned unchanged. */
export function formatUsPhoneForDisplay(phoneE164: string): string {
  const match = US_E164.exec(phoneE164);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneE164;
}

/** True when two entries name the same valid US number, however each is formatted. */
export function isSameUsNumber(left: string, right: string): boolean {
  const leftE164 = normalizeContactPhoneToE164(left);
  return leftE164 !== undefined && leftE164 === normalizeContactPhoneToE164(right);
}

/** The server masks all but the last two digits, e.g. "+15*******00"; the field already shows the +1. */
export function formatMaskedUsNumber(masked: string): string {
  const national = (masked.startsWith('+1') ? masked.slice(2) : masked).replaceAll('*', '•');
  if (national.length !== 10) {
    return national;
  }
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}

/** The masked number in full, with its +1, for text rather than the phone field. */
export function formatMaskedUsPhone(masked: string): string {
  if (!masked.startsWith('+1')) return masked.replaceAll('*', '•');
  return `+1 ${formatMaskedUsNumber(masked)}`;
}
